import { SIGNUP_BONUS_AMOUNT } from '../../lib/types';

export default function StatsBar() {
  const stats = [
    { value: '6', label: 'Question Formats' },
    { value: <>&#8377;5</>, label: 'Starting Price Per Question' },
    { value: <>&#8377;{SIGNUP_BONUS_AMOUNT}</>, label: 'Free Signup Credit' },
    { value: <>&#8377;0</>, label: 'Subscription Fee' },
  ];

  return (
    <section className="border-y border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat) => (
            <div key={stat.label}>
              <div className="text-3xl sm:text-4xl font-extrabold text-teal-600">
                {stat.value}
              </div>
              <div className="text-sm text-slate-500 mt-1 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
